'use client';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/ui/shadcn/dialog';
import { Button } from '@/shared/ui/shadcn/button';

export interface SessionTimeoutDialogProps {
  open: boolean;
  remainingMs: number;
  onStaySignedIn: () => void;
  onLogoutNow: () => void;
}

function formatRemainingTime(remainingMs: number): string {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const paddedSeconds = seconds < 10 ? `0${String(seconds)}` : String(seconds);
  return `${String(minutes)}:${paddedSeconds}`;
}

export function SessionTimeoutDialog({
  open,
  remainingMs,
  onStaySignedIn,
  onLogoutNow,
}: SessionTimeoutDialogProps) {
  const titleId = 'session-timeout-dialog-title';
  const descriptionId = 'session-timeout-dialog-description';
  const formattedCountdown = formatRemainingTime(remainingMs);

  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        aria-labelledby={titleId}
        aria-describedby={descriptionId}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onInteractOutside={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle id={titleId}>You will be logged out soon</DialogTitle>
          <DialogDescription id={descriptionId}>
            Due to inactivity, you will be logged out in{' '}
            <span className="font-semibold text-foreground">{formattedCountdown}</span>.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onStaySignedIn}>
            Stay signed in
          </Button>
          <Button type="button" variant="destructive" onClick={onLogoutNow}>
            Log out now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
